import createApiClient from './api';


const api = createApiClient();

// Get templates for a project
export const fetchTemplates = async (projectId, type = null, page = 1, limit = 100) => {
  const params = {
    project_id: projectId,
    page: page.toString(),
    limit: limit.toString(),
  };
  
  if (type) {
    params.type = type;
  }

  const response = await api.get('/templates/', {
    params,
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('token')}`,
    },
  });

  return response.data;
};

// Get a single template by ID
export const fetchTemplate = async (templateId) => {
  const response = await api.get(`/templates/${templateId}`, {
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('token')}`,
    },
  });

  return response.data;
};

// Create a new template
export const createTemplate = async (templateData) => {
  const response = await api.post('/templates/', templateData, {
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('token')}`,
    },
  });

  return response.data;
};

// Update a template
export const updateTemplate = async (templateId, templateData) => {
  const response = await api.put(`/templates/${templateId}`, templateData, {
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('token')}`,
    },
  });

  return response.data;
};

// Delete a template
export const deleteTemplate = async (templateId) => {
  const response = await api.delete(`/templates/${templateId}`, {
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('token')}`,
    },
  });

  return response.data;
};
